import {AppCodeUse, Collection, Experience, ExperienceMessage, User} from 'data/records'
import {appCodeUseInitialState, appCodeUseReducers} from 'data/resources/appCodeUses'
import {collectionReducers, collectionInitialState} from 'data/resources/collections'
import {experienceInitialState, experienceReducers} from 'data/resources/experiences'
import {experienceMessageInitialState, experienceMessageReducers} from 'data/resources/experienceMessages'
import {favoriteReducers} from 'data/resources/favorites'
import {liveLogReducers} from 'data/resources/liveLogs'
import {routeReducers} from 'data/resources/routes'
import {routeSetOverviewReducers} from 'data/resources/routeSetOverviews'
import {segmentMatchReducers} from 'data/resources/segmentMatches'
import {tripReducers} from 'data/resources/trips'
import {userInitialState, userReducers} from 'data/resources/users'

// All apiv3 resource reducers to be run after the default record/collection/extras reducers
export const resourceReducers = {
  ...appCodeUseReducers,
  ...collectionReducers,
  ...experienceReducers,
  ...experienceMessageReducers,
  ...favoriteReducers,
  ...liveLogReducers,
  ...routeReducers,
  ...routeSetOverviewReducers,
  ...segmentMatchReducers,
  ...tripReducers,
  ...userReducers
}

// All apiv3 resource state to be included in addition to standard record-by-id mapping
export const resourceState = [
  [AppCodeUse, appCodeUseInitialState],
  [Collection, collectionInitialState],
  [Experience, experienceInitialState],
  [ExperienceMessage, experienceMessageInitialState],
  [User, userInitialState]
]
